import React, { useEffect } from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import { setLoadingContext } from '../../utils/axiosConfig';
import Loader from './Loader';

const GlobalLoader: React.FC = () => {
  const { isLoading, setLoading } = useLoading();

  useEffect(() => {
    setLoadingContext({ setLoading });
  }, [setLoading]);

  return isLoading ? <Loader /> : null;
};

export default GlobalLoader;

